export function setUsability(data) {
  return {
    type: 'SET_USABILITY',
    payload: data,
  }
}
